import './styles.css';
import { useParams, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { ConfigProvider, Tabs, Skeleton, Pagination } from 'antd';
import ItemCard from '../../components/ItemCard';

const RussiaFlag = () => (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" style={{ borderRadius: 2, flexShrink: 0 }}>
        <rect width="20" height="4.67" fill="white" />
        <rect y="4.67" width="20" height="4.67" fill="#0039A6" />
        <rect y="9.33" width="20" height="4.67" fill="#D52B1E" />
    </svg>
);

const SellerPageSkeleton = () => (
    <div className="seller-page-container">
        <div className="seller-header">
            <div className="seller-logo-block">
                <Skeleton.Image active style={{ width: 120, height: 120, borderRadius: 12 }} />
            </div>
            <div className="seller-header-info">
                <Skeleton.Input active size="large" style={{ width: 280, height: 36, marginBottom: 10 }} />
                <Skeleton.Input active size="small" style={{ width: 200, height: 20, marginBottom: 8 }} />
                <Skeleton.Input active size="small" style={{ width: 300, height: 18, marginBottom: 16 }} />
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {Array(6).fill(null).map((_, i) => (
                        <Skeleton.Button key={i} active size="small" style={{ width: 90, height: 28 }} />
                    ))}
                </div>
            </div>
        </div>

        <div className="seller-divider" />

        <div style={{ display: 'flex', gap: 20, borderBottom: '1px solid #444', paddingBottom: 10, marginBottom: 20 }}>
            <Skeleton.Input active size="small" style={{ width: 100, height: 24 }} />
            <Skeleton.Input active size="small" style={{ width: 100, height: 24 }} />
        </div>

        <div className="seller-about-content">
            <Skeleton active paragraph={{ rows: 4, width: ['100%', '95%', '90%', '80%'] }} title={false} />
        </div>
    </div>
);

const ProductCardSkeleton = () => (
    <div className="seller-product-card-skeleton">
        <Skeleton.Image active style={{ width: '100%', aspectRatio: '1/1' }} />
        <div style={{ padding: '12px 0' }}>
            <Skeleton active paragraph={{ rows: 2, width: ['100%', '60%'] }} title={false} />
            <Skeleton.Input active size="small" style={{ width: '50%', marginTop: 8 }} />
        </div>
    </div>
);

const SellerPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { sellerId } = useParams();

    const [activeTab, setActiveTab] = useState('about');
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(8);

    const isLoading = false;
    const isProductsLoading = false;
    const seller = {
        id: 1,
        name: 'Protect&Feed',
        logo: 'https://placehold.co/120x120/1a1a2e/fff?text=PF',
        location: 'Россия, г. Усть-Лабинск',
        activity: 'Кормопроизводство и растениеводство',
        description: 'Компания Protect&Feed сотрудничает с ведущими специалистами, ветеринарными врачами, кандидатами наук. Предоставляем консультативную помощь по самым разным вопросам с выездом специалиста в Краснодаре и Краснодарском крае, а так же других регионах России. Демократичная цена на услуги позволяет нашим клиентам обращаться к нам постоянно.',
        categories: [
            { id: 1, name: 'Для коров' },
            { id: 2, name: 'Для коз' },
            { id: 3, name: 'Для овец' },
            { id: 4, name: 'Растениеводство' },
            { id: 5, name: 'Лекарства' },
            { id: 6, name: 'Для овец' },
            { id: 7, name: 'Растениеводство' },
            { id: 8, name: 'Лекарства' },
        ],
    };
    const products = Array(8).fill(null).map((_, i) => ({
        id: i + 1,
        name: 'Комбикорм Куил старт (перепелки 0-28дн)',
        main_image: 'https://placehold.co/250x250/f5f5f5/333?text=Product',
        price: 5999,
        old_price: 7999,
        discount: 10,
        average_rating: 4.9,
        rating_count: 10,
        seller_company: { id: 1, name: 'ООО "Протектфид"' },
        categories: [{ id: 1, name: 'для Птицы' }, { id: 2, name: 'Комбикорм' }],
    }));
    const totalProducts = 24;

    useEffect(() => {
        if (sellerId) {
        }
    }, [dispatch, sellerId]);

    useEffect(() => {
        if (sellerId && activeTab === 'products') {
        }
    }, [dispatch, sellerId, currentPage, activeTab, productsPerPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleCategoryClick = (categoryId) => {
        navigate(`/category/${categoryId}`);
    };

    if (isLoading) {
        return <SellerPageSkeleton />;
    }

    if (!seller) {
        return (
            <div className="seller-page-container">
                <div className="seller-not-found">Продавец не найден</div>
            </div>
        );
    }

    const AboutContent = () => (
        <div className="seller-about-content">
            {seller.description ? (
                seller.description.split('\n').filter(Boolean).map((paragraph, idx) => (
                    <p key={idx}>{paragraph}</p>
                ))
            ) : (
                <p>Информация о компании отсутствует.</p>
            )}
        </div>
    );

    const ProductsContent = () => (
        <div className="seller-products-content">
            {isProductsLoading ? (
                <div className="seller-products-grid">
                    {Array(productsPerPage).fill(null).map((_, i) => (
                        <ProductCardSkeleton key={i} />
                    ))}
                </div>
            ) : products.length > 0 ? (
                <>
                    <div className="seller-products-grid">
                        {products.map((product) => (
                            <ItemCard
                                key={product.id}
                                id={product.id}
                                main_image={product.main_image}
                                name={product.name}
                                average_rating={product.average_rating}
                                rating_count={product.rating_count}
                                price={product.price}
                                seller_company={product.seller_company}
                                categories={product.categories}
                                item={product}
                            />
                        ))}
                    </div>

                    {totalProducts > productsPerPage && (
                        <div className="seller-products-pagination">
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Pagination: {
                                            itemActiveBg: '#DC0202',
                                            itemBg: 'transparent',
                                            colorText: '#fff',
                                            colorPrimary: '#fff',
                                            colorPrimaryHover: '#DC0202',
                                            colorBorder: '#444',
                                            colorBgTextHover: 'rgba(255,255,255,0.1)',
                                        },
                                    },
                                }}
                            >
                                <Pagination
                                    current={currentPage}
                                    total={totalProducts}
                                    pageSize={productsPerPage}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                />
                            </ConfigProvider>
                        </div>
                    )}
                </>
            ) : (
                <div className="seller-products-empty">
                    У данного продавца пока нет товаров.
                </div>
            )}
        </div>
    );

    const tabItems = [
        { key: 'about', label: 'О компании', children: <AboutContent /> },
        { key: 'products', label: 'Продукция', children: <ProductsContent /> },
    ];

    return (
        <div className="seller-page-container">
            <div className="seller-header">
                <div className="seller-logo-block">
                    {seller.logo ? (
                        <img
                            className="seller-logo-img"
                            src={seller.logo}
                            alt={seller.name}
                        />
                    ) : (
                        <div className="seller-logo-placeholder">
                            {seller.name?.charAt(0)}
                        </div>
                    )}
                </div>

                <div className="seller-header-info">
                    <h1 className="seller-name">{seller.name}</h1>

                    <div className="seller-location">
                        <RussiaFlag />
                        <span>{seller.location}</span>
                    </div>

                    <div className="seller-activity">{seller.activity}</div>

                    {seller.categories && seller.categories.length > 0 && (
                        <div className="seller-categories">
                            <div className="seller-categories-label">Категории:</div>
                            <div className="seller-categories-list">
                                {seller.categories.map((cat) => (
                                    <a
                                        key={cat.id}
                                        className="seller-category-tag"
                                        onClick={() => handleCategoryClick(cat.id)}
                                    >
                                        {cat.name}
                                    </a>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="seller-tabs-wrapper">
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: '#ffffff',
                            colorPrimaryHover: '#cccccc',
                        },
                        components: {
                            Tabs: {
                                itemColor: '#818181',
                                itemSelectedColor: '#ffffff',
                                itemActiveColor: '#ffffff',
                                itemHoverColor: '#cccccc',
                                inkBarColor: '#ffffff',
                                titleFontSize: 16,
                            },
                        },
                    }}
                >
                    <Tabs
                        activeKey={activeTab}
                        onChange={(key) => {
                            setActiveTab(key);
                            if (key === 'products') setCurrentPage(1);
                        }}
                        items={tabItems}
                        className="custom-dark-tabs seller-tabs"
                    />
                </ConfigProvider>
            </div>
        </div>
    );
};

export default SellerPage;